// Angular
import { Directive, Input, ViewContainerRef, TemplateRef } from '@angular/core';
import { OnDestroy, OnInit } from '@angular/core';

// Rxjs
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Services
import { AuthenticationService } from 'app/_services';

@Directive({
    selector: '[appHasRole]'
})
export class HasRoleDirective implements OnInit, OnDestroy {
    @Input() appHasRole: string[];

    private stop$ = new Subject();
    private isVisible = false;

    constructor(
        private viewContainerRef: ViewContainerRef,
        private templateRef: TemplateRef<any>,
        private rolesService: AuthenticationService
    ) { }

    ngOnInit() {
        this.rolesService.getRoles()
            .pipe(takeUntil(this.stop$))
            .subscribe(
                (roles) => {
                    if (!roles) {
                        this.viewContainerRef.clear();
                    }

                    if (this.appHasRole === undefined) {
                        this.isVisible = true;
                        this.viewContainerRef.createEmbeddedView(this.templateRef);
                    } else if (roles.some(r => this.appHasRole.includes(r))) {
                        if (!this.isVisible) {
                            this.isVisible = true;
                            this.viewContainerRef.createEmbeddedView(this.templateRef);
                        }
                    } else {
                        this.isVisible = false;
                        this.viewContainerRef.clear();
                    }
                },
                error => {
                    console.error(error);
                },
                () => {
                    console.log('Done');
                }
            );
    }

    ngOnDestroy() {
        this.stop$.next();
    }
}
